// Modelos "Ugarqui" oferecidos no seletor do chat (Regra 4). Os `id` DEVEM bater com os do
// backend (AssistenteModelos em appsettings / OpenAIToolSchema.Nivel*). `aceitaAnexos` reflete a
// capacidade de imagem/áudio de cada nível (2026-07-13: todos os níveis aceitam) — se algum nível
// voltar a não aceitar, o backend rejeita e a interface desabilita anexar/gravar pra esse nível.
// Paridade com o stack Angular.

export interface AcaoRapida {
    rotulo: string;
    template: string;
}

/** Metadata de menu de um comando slash (/comando) — espelha ComandoMenuDto do backend. Nunca
 *  inclui a diretiva (essa é server-only, injetada no system prompt). */
export interface ComandoMenu {
    comando: string;
    rotulo: string;
    descricao: string;
    icone: string;
    niveis: string[];
    exemploPrompt: string | null;
}

export interface ModeloUgarqui {
    id: string;
    nome: string;
    // Selo curto ao lado do nome (substitui a descrição longa no menu do seletor).
    badge: string;
    aceitaAnexos: boolean;
    // `bloqueado`: aparece no seletor mas não pode ser escolhido (teaser de modelo futuro).
    bloqueado?: boolean;
    // Até 3 atalhos que pré-preenchem o campo de mensagem (Fase 1 — botões por modelo).
    acoesRapidas?: AcaoRapida[];
}

export const MODELOS_UGARQUI: ModeloUgarqui[] = [
    {
        id: 'ugarqui-1.0',
        nome: 'Ugarqui 1.0',
        badge: 'Rápido',
        aceitaAnexos: true,
        acoesRapidas: [
            { rotulo: 'Consultar arquitetura', template: 'Onde no projeto fica ' },
            { rotulo: 'Encontrar exemplo', template: 'Me mostra um exemplo real já implementado no projeto de ' },
            { rotulo: 'Explicar padrão', template: 'Explica como funciona o padrão ' },
        ],
    },
    {
        id: 'ugarqui-1.0-pro',
        nome: 'Ugarqui 1.0 Pro',
        badge: 'Dev',
        aceitaAnexos: true,
        acoesRapidas: [
            { rotulo: 'Gerar estrutura', template: 'Gera a estrutura de arquivos (scaffold) seguindo o padrão do projeto para: ' },
            { rotulo: 'Revisar código', template: 'Revisa este trecho de código seguindo os padrões do projeto:\n\n' },
            { rotulo: 'Criar checklist', template: 'Cria um checklist do que preciso fazer para implementar: ' },
        ],
    },
    {
        id: 'ugarqui-2.0-alto',
        nome: 'Ugarqui 2.0 Alto',
        badge: 'Avançado',
        aceitaAnexos: true,
        acoesRapidas: [
            { rotulo: 'Analisar impacto', template: 'Analisa o impacto de fazer esta mudança: ' },
            { rotulo: 'Criar blueprint', template: 'Monta um blueprint de como estruturar: ' },
            { rotulo: 'Gerar diagrama', template: 'Gera um diagrama técnico mostrando ' },
        ],
    },
    {
        id: 'ugarqui-arquiteto-3.0',
        nome: 'Ugarqui Arquiteto 3.0',
        badge: 'Restrito',
        aceitaAnexos: true,
        bloqueado: true,
        acoesRapidas: [
            { rotulo: 'Blueprint completo', template: 'Monta um blueprint completo, com diagramas, de: ' },
            { rotulo: 'Auditoria de arquitetura', template: 'Faz uma auditoria de arquitetura completa em: ' },
            { rotulo: 'Decisão técnica', template: 'Compara as opções e recomenda a decisão técnica para: ' },
        ],
    },
];

export const MODELO_PADRAO = 'ugarqui-1.0-pro';

/** Nível "topo" (2026-07-13) — diagramas Mermaid e PDF exportado ganham um visual mais elaborado
 *  (ver `mermaid-renderer.ts`/`pdf-ugarqui.ts`) só quando este é o modelo ativo da conversa. */
export const MODELO_PREMIUM = 'ugarqui-arquiteto-3.0';

export function ehModeloPremium(id: string): boolean {
    return id === MODELO_PREMIUM;
}

export function modeloAceitaAnexos(id: string): boolean {
    return MODELOS_UGARQUI.find((modelo) => modelo.id === id)?.aceitaAnexos ?? true;
}

export type VarianteBadge = 'rapido' | 'dev' | 'avancado' | 'restrito' | 'neutro';

/** Mapeia o texto do badge do modelo para uma variante de estilo (cor). Só cores já no DS. */
export function corBadgeDoModelo(badge: string): VarianteBadge {
    switch (badge) {
        case 'Rápido': return 'rapido';
        case 'Dev': return 'dev';
        case 'Avançado': return 'avancado';
        case 'Restrito': return 'restrito';
        default: return 'neutro';
    }
}
